import { render, staticRenderFns } from "./tabel_5.vue?vue&type=template&id=117e116a&"
import script from "./tabel_5.vue?vue&type=script&lang=js&"
export * from "./tabel_5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports